export default __webpack_public_path__ + "static/firewood-stack-dark-153058b527bc10527d22b498ad95cd16.jpg";